<div class=" bg-gray-100 py-6 flex flex-col justify-center sm:py-12">

    <!-- Basic -->
    <div class="mx-4">
        <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                            <!-- Title -->
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        Title
                                    </label>
                                    <div class="mt-1 flex rounded-md ">
                                        <div class="ql-container ql-snow" style="border-width: 0;">
                                            <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                                [innerHTML]="title | noSanitize">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Keywords -->
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        Keywords
                                    </label>
                                    <div class="mt-1 flex rounded-md ">
                                        <div class="ql-container ql-snow" style="border-width: 0;">
                                            <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                                [innerHTML]="keywords | noSanitize">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Summary -->
                            <div>
                                <label for="about" class="block text-sm font-medium text-gray-700">
                                    Summary
                                </label>
                                <div class="mt-1">
                                    <div class="ql-container ql-snow" style="border-width: 0;">
                                        <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                            [innerHTML]="summary | noSanitize">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900"></h3>
                </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">

                            <!-- Country -->
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        Country
                                    </label>
                                    <div class="mt-1 flex rounded-md ">
                                        <div class="ql-container ql-snow" style="border-width: 0;">
                                            <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                                [innerHTML]="country | noSanitize">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- City -->
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        City
                                    </label>
                                    <div class="mt-1 flex rounded-md ">
                                        <div class="ql-container ql-snow" style="border-width: 0;">
                                            <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                                [innerHTML]="city | noSanitize">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Zip Code -->
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        Zip Code
                                    </label>
                                    <div class="mt-1 flex rounded-md ">
                                        <div class="ql-container ql-snow" style="border-width: 0;">
                                            <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                                [innerHTML]="zipCode | noSanitize">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- City population -->
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        City Population
                                    </label>
                                    <div class="mt-1 flex rounded-md ">
                                        <div class="ql-container ql-snow" style="border-width: 0;">
                                            <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                                [innerHTML]="cityPopulation | noSanitize">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Duration From -->
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        Year of Implementation
                                    </label>
                                    <div class="mt-1 flex rounded-md ">
                                        <div class="ql-container ql-snow" style="border-width: 0;">
                                            <div class="ql-editor rounded-md sm:text-sm border-gray-300"
                                                [innerHTML]="durationFrom | noSanitize">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--  Overview -->
    <div class="hidden sm:block" aria-hidden="true">
        <div class="py-5">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>

    <div class="mt-10 sm:mt-0 mx-4">
        <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow overflow-hidden sm:rounded-md">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">

                            <!-- Overview -->
                            <div>
                                <label for="about" class="block text-sm font-medium text-gray-700">
                                    Overview
                                </label>
                                <div class="mt-1 flex rounded-md ">
                                    <div class="ql-container ql-snow" style="border-width: 0;">
                                        <div class="ql-editor sm:text-sm border border-gray-300"
                                            [innerHTML]="overview | noSanitize">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Implementation Activities -->
    <div class="hidden sm:block" aria-hidden="true">
        <div class="py-5">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>

    <div class="mt-10 sm:mt-0 mx-4">
        <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow overflow-hidden sm:rounded-md">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6" *ngFor="let implementation of implementations">

                            <!-- Content -->
                            <div>
                                <label for="about" class="block text-sm font-medium text-gray-700">
                                    Concrete Actions
                                </label>
                                <div class="mt-1 flex rounded-md ">
                                    <div class="ql-container ql-snow" style="border-width: 0;">
                                        <div class="ql-editor sm:text-sm border border-gray-300"
                                            [innerHTML]="implementation.content | noSanitize">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Multi-Objective Approach -->
    <div class="hidden sm:block" aria-hidden="true">
        <div class="py-5">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>

    <div class="mt-10 sm:mt-0 mx-4">
        <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow overflow-hidden sm:rounded-md">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6" *ngFor="let multi of multiObjective">

                            <!-- Content -->
                            <div>
                                <label for="about" class="block text-sm font-medium text-gray-700">
                                    Lessons Learned
                                </label>
                                <div class="mt-1 flex rounded-md ">
                                    <div class="ql-container ql-snow" style="border-width: 0;">
                                        <div class="ql-editor sm:text-sm border border-gray-300"
                                            [innerHTML]="multi.content | noSanitize">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- References -->
    <div class="hidden sm:block" aria-hidden="true">
        <div class="py-5">
            <div class="border-t border-gray-200"></div>
        </div>
    </div>

    <div class="mt-10 sm:mt-0 mx-4">
        <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div>
                    <div class="shadow overflow-hidden sm:rounded-md">
                        <div class="px-4 py-5 bg-white space-y-6 sm:p-6">

                            <!-- References -->
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <label for="company-website" class="block text-sm font-medium text-gray-700">
                                        Links
                                    </label>
                                    <div class="mt-2 rounded-md ">
                                        <div class="ql-container ql-snow" style="border-width: 0;">
                                            <div class="ql-editor sm:text-sm border border-gray-300"
                                                [innerHTML]="references | noSanitize">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="justify-self-end ml-auto w-3/12">
        <button
            class=" w-1/4 my-4 bg-green-400 hover:bg-green-300 rounded text-white p-2 pl-4 pr-4"
            (click)="publish()">
            Publish
        </button>
        <button
            class="w-1/4 my-4 bg-red-400 hover:bg-red-300 rounded text-white ml-5 p-2 pl-4 pr-4"
            (click)="unpublish()">
            Reject
        </button>
    </div>
</div>